import { theme } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

const List = styled.ul`
  padding-left: ${theme.space[8]};
  margin-bottom: ${theme.space[0]};
`;

export default List;
